import { toast } from "react-toastify";

export const handleNetworkError = (
  error,
  returnMessage = false,
  useToast = true
) => {
  console.log("error handler error", error, error.response);

  // Check if this is a token expiration error - handle both old and new formats
  const isTokenExpired =
    (error?.response?.status === 403 &&
      error?.response?.data?.detail === "Invalid token.") ||
    (error?.response?.status === 401 &&
      error?.response?.data?.code === "token_not_valid");

  if (
    error.response &&
    error.response.data?.non_field_errors &&
    error.response.data?.non_field_errors[0]
  ) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    let message = error.response.data?.non_field_errors[0];

    // Don't show toast for token expiration - navigation will handle it
    if (useToast && !isTokenExpired) {
      toast.error(message);
    } else if (returnMessage) {
      return message;
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js

    let message =
      "An error occurred communicating with the server, " +
      "please check your internet connection.";

    if (useToast && !isTokenExpired) {
      toast.error(message);
    } else if (returnMessage) {
      return message;
    }
  } else {
    // Something happened in setting up the request that triggered an Error

    let message = "A network error occurred.";

    console.log("Error", error.message);

    if (useToast && !isTokenExpired) {
      toast.error(message);
    } else if (returnMessage) {
      return message;
    }
  }
  console.log("network error", error);
};
